const caseTypes = "case-types";
const caseSummary = "case-summary";
const snippets = "snippets";
const userRoles = "user-roles";

const queryKeys = {
  caseTypes,
  caseSummary,
  snippets,
  userRoles,
};

export default queryKeys;
